// Config for firebase

import Firebase from 'firebase/app'
var FireDb = Firebase.initializeApp({
  apiKey: 'AIzaSyAvAbnDvkAa-PienNkP_KRCJh2doVTcCbI',
  authDomain: 'record-union-3224.firebaseapp.com',
  databaseURL: 'https://record-union-3224.firebaseio.com',
  projectId: 'record-union-3224',
  storageBucket: 'record-union-3224.appspot.com',
  messagingSenderId: '821611269933'
})

export default FireDb
